import { AccredibleAccountsRedirectionServiceModule } from '@accredible-frontend-v2/services/accounts-redirection';
import {
  AccredibleAuthenticationServiceModule,
  WHOAMI_BASE_PATH,
} from '@accredible-frontend-v2/services/authentication';
import { AccredibleBrowserStorageServiceModule } from '@accredible-frontend-v2/services/browser-storage';
import { AccredibleCookiesServiceModule } from '@accredible-frontend-v2/services/cookies';
import { AccredibleLanguageServiceModule } from '@accredible-frontend-v2/services/language';
import { AccredibleUserServiceModule } from '@accredible-frontend-v2/services/user';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Routes, withInMemoryScrolling } from '@angular/router';
import { ShellComponent } from '@ler/feature-layout';
import { lerAuthGuard } from './core/ler-auth.guard';
import { LerLoadService } from './core/ler-load.service';

const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    canActivate: [lerAuthGuard],
    children: [
      {
        path: 'speak-your-skills/:credentialId',
        loadChildren: () =>
          import('@ler/feature-speak-your-skills').then((m) => m.SpeakYourSkillsRoutes),
      },
    ],
  },
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
      }),
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    importProvidersFrom(
      AccredibleBrowserStorageServiceModule,
      AccredibleCookiesServiceModule,
      AccredibleUserServiceModule,
      AccredibleAccountsRedirectionServiceModule,
      AccredibleAuthenticationServiceModule.forRoot({ app: 'ler' }),
      AccredibleLanguageServiceModule.forRoot(['en']),
    ),
    { provide: WHOAMI_BASE_PATH, useValue: '/v1/ler/user/whoami' },
    LerLoadService,
    {
      provide: APP_INITIALIZER,
      useFactory: (loadService: LerLoadService) => () => loadService.initializeApp(),
      deps: [LerLoadService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (loadService: LerLoadService) => () => loadService.validateAuthenticationToken(),
      deps: [LerLoadService],
      multi: true,
    },
  ],
};
